import { useNotifications } from '../contexts/NotificationContext';
import { NotificationType } from '../types/notification';

interface CreateNotificationOptions {
  title: string;
  message: string;
  type?: NotificationType;
  link?: string;
  linkText?: string;
}

export const useCreateNotification = () => {
  const { createNotification } = useNotifications();

  const notify = ({
    title,
    message,
    type = 'info',
    link,
    linkText,
  }: CreateNotificationOptions) => {
    createNotification({
      title,
      message,
      type,
      link,
      linkText,
    });
  };

  return notify;
};

export default useCreateNotification; 